export default __webpack_public_path__ + "static/media/p3.41e27717.jpg";